import { defineRecipe } from "@chakra-ui/react";

export const buttonRecipe = defineRecipe({
  base: {
    borderRadius: "full",
  },
  variants: {
    variant: {
      "empty-link": {
        _hover: {
          textDecoration: "underline",
          textDecorationColor: "currentColor/20",
          textUnderlineOffset: "3px",
        },
        alignItems: "center",
        bg: "transparent",

        border: 0,
        borderRadius: "l1",
        color: "text.fg_muted",

        cursor: "pointer",
        focusRing: "none",
        font: "inherit",
        fontSize: "inherit",
        gap: "1.5",
        height: "auto",
        lineHeight: "inherit",

        margin: 0,
        minW: "unset",
        outline: "none",

        padding: 0,
        textDecoration: "none",
        textUnderlineOffset: "3px",

        verticalAlign: "baseline",
      },
      "underline-link": {
        _hover: {
          textDecoration: "underline",
          textDecorationColor: "currentColor/20",
          textUnderlineOffset: "3px",
        },
        alignItems: "center",
        bg: "transparent",

        border: 0,
        borderRadius: "l1",
        color: "text.fg_accent",

        cursor: "pointer",
        focusRing: "outside",
        font: "inherit",
        fontSize: "inherit",
        gap: "1.5",
        height: "auto",
        lineHeight: "inherit",

        margin: 0,
        minW: "unset",
        outline: "none",

        padding: 0,
        textDecoration: "underline",
        textUnderlineOffset: "3px",

        verticalAlign: "baseline",
      },
    },
  },
});
